export default "__VITE_ASSET__DrzYpvOX__"